import './App.css';
import * as React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {createTheme, responsiveFontSizes, ThemeProvider} from "@material-ui/core";
import MapContainer from "./components/mapContainer";
import DataContextProvider from './contexts/DataContext'
import { Authenticator } from '@aws-amplify/ui-react';


const useStyles = makeStyles({
    app: {
        height: '100dvh', // dynamic viewport height: excludes the mobile browser bars
        fallbacks: {height: '100vh'},
        width: '100vw',
    }
})

// responsiveFontSizes: headings scale down on small screens (unchanged on desktop)
const theme = responsiveFontSizes(createTheme({
    typography: {
        fontFamily: 'Comfortaa',
        fontWeightRegular: 600
    }
}))

export default function App() {
    const classes = useStyles()

    return (
        <Authenticator.Provider>
            <DataContextProvider>
                <ThemeProvider theme={theme}>
                    <div className={classes.app}>
                        {/*<SearchAppBar title={'Tropical Cyclone Platform'} layersName={'layers'}/>*/}
                        {/*<MapContainer />*/}
                        <MapContainer />
                        {/*<EnhancedTable />*/}
                        {/*<PieChartCountry />*/}
                        {/*<PieChart />*/}
                        {/*<PieChartHover />*/}
                        {/*<ChartContainer />*/}
                        {/*<ExposureTable2 />*/}
                    </div>
                </ThemeProvider>
            </DataContextProvider>
        </Authenticator.Provider>
    );
}
